import { computed, ref } from 'vue'

export const POLL_INTERVAL_MS = 2500
export const MAX_POLL_FAILURES = 5
export const CUSTOMERS_IMPORT_TYPE = 'UsersImport'

const TERMINAL_STATUSES = ['completed', 'failed']

// Module scope, not component state: the whole point is to outlive the wizard
// that started the run, so the setup drawer can go on showing it after the
// merchant has closed the modal and walked away.
const importType = ref(null)
const status = ref(null)
const summary = ref(null)

let timer = null
let generation = 0

export function clearImportRun() {
  generation += 1
  if (timer) clearTimeout(timer)
  timer = null
  importType.value = null
  status.value = null
  summary.value = null
}

export function trackImportRun({ importId, importType: type, call }) {
  clearImportRun()
  const mine = (generation += 1)
  importType.value = type
  status.value = 'running'
  let failures = 0

  const poll = async () => {
    if (mine !== generation) return
    try {
      const response = await call('GET', `imports/${importId}`, {}, { receive: false })
      if (mine !== generation) return
      failures = 0
      const latest = response && response.data && response.data.data && response.data.data.attributes.latest_run
      if (!latest || !TERMINAL_STATUSES.includes(latest.status)) {
        timer = setTimeout(poll, POLL_INTERVAL_MS)
        return
      }
      status.value = latest.status
      summary.value = latest.summary || null
    } catch (error) {
      if (mine !== generation) return
      failures += 1
      // Losing the connection says nothing about the import, so this stops
      // watching rather than claiming the run failed.
      if (failures < MAX_POLL_FAILURES) timer = setTimeout(poll, POLL_INTERVAL_MS)
      else status.value = 'unknown'
    }
  }

  poll()
}

export function useImportRunTracker() {
  return {
    importType,
    status,
    summary,
    running: computed(() => status.value === 'running'),
    finished: computed(() => status.value !== null && status.value !== 'running'),
    clear: clearImportRun
  }
}
